import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions'; // execApi,
import { openErrorDialog, openSuccessDialog } from '../dialog/dialogActions';
import AppointmentsApi from '../../apis/appointments';


export const confirm = (appointment, successCb) => {
    return dispatch => {
        dispatch(execApiWithParam({
            type: types.CONFIRM_APPOINTMENT,
            api: AppointmentsApi.confirmAppointment,
            param: appointment,
            successCallback: response => {
                dispatch(openSuccessDialog({
                    title: 'Successfully Sent',
                    content: 'Your appointment confirmation request has been sent.',
                    okCallback: () => {
                        // Refresh after confirmation success
                        dispatch(getUpcomingAppointments());

                        return true;
                    },
                }));
            },
            // Our 'success: false' response object. Also called on catch of an exception.
            errorCallback: response => {
                dispatch(openErrorDialog({
                    title: 'Unable to Confirm',
                    content: response.message.body,
                }));
            },
            useErrorDialog: true,
        }));
    };
};

export const cancel = (appointment, successCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.CANCEL_APPOINTMENT,
      api: AppointmentsApi.cancelAppointment,
      param: appointment,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Successfully Sent',
          content: 'Your appointment cancellation request has been sent.',
          okCallback: () => {
            // Refresh after cancellation success
            dispatch(getUpcomingAppointments());

            return true;
          },
        }));
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        dispatch(openErrorDialog({
          title: 'Unable to Cancel',
          content: response.message.body,
        }));
      },
      useErrorDialog: true,
    }));
  };
};

export const email = (appointment, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.EMAIL_APPOINTMENT,
      api: AppointmentsApi.emailAppointment,
      param: appointment,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Successfully Sent',
          content: 'We successfully emailed your appointment details.',
        }));

        // For turning off fullPageLoadingState in the component
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        dispatch(openErrorDialog({
          title: 'Unable to Email',
          content: response.message.body,
        }));

        // For turning off fullPageLoadingState in the component
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const getAllSlots = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.GET_ALL_SLOTS,
      api: AppointmentsApi.getAllSlots,
      param: data,
      successCallback: response => {
        dispatch({
          type: types.GET_ALL_SLOTS,
          payload: response.slots,
        });

        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        // The response.message.body is parsed in the SchedulingContainer to display
        if (errorCb) errorCb(response);
      },
    }));
  };
};

export const getAppointmentMessageRecipients = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_APPOINTMENT_MESSAGE_RECIPIENTS,
      api: AppointmentsApi.getAppointmentMessageRecipients,
      successCallback: response => {
        dispatch({
          type: types.GET_APPOINTMENT_MESSAGE_RECIPIENTS,
          payload: response.recipients,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const getDefaultEmailRecipient = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_DEFAULT_EMAIL_RECIPIENT,
      api: AppointmentsApi.getDefaultEmailRecipient,
      successCallback: response => {
        dispatch({
          type: types.GET_DEFAULT_EMAIL_RECIPIENT,
          payload: response.email,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const getFilter = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.GET_FILTER,
      api: AppointmentsApi.getFilter,
      param: data,
      successCallback: response => {
        dispatch({
          type: types.GET_FILTER,
          payload: response.items,
        });

        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        // The response.message.body is parsed in the SchedulingContainer to display
        if (errorCb) errorCb(response);
      },
    }));
  };
};

export const getAppointmentTimeRange = (data, successCb, errorCb) => {
    return dispatch => {
        dispatch(execApiWithParam({
            type: types.GET_APPOINTMENT_TIME_RANGE,
            api: AppointmentsApi.getAppointmentTimeRange,
            param: data,
            successCallback: response => {
                dispatch({
                    type: types.GET_APPOINTMENT_TIME_RANGE,
                    payload: response,
                });
                if (successCb) successCb(response);
            },
            // Our 'success: false' response object. Also called on catch of an exception.
            errorCallback: response => {
                // The response.message.body is parsed in the SchedulingContainer to display
                if (errorCb) errorCb(response);
            },
        }));
    };
};

export const getFilterLabels = successCb => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_FILTER_LABELS,
      api: AppointmentsApi.getFilterLabels,
      successCallback: response => {
        dispatch({
          type: types.GET_FILTER_LABELS,
          payload: response.labels,
        });

        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const getPastAppointments = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_PAST_APPOINTMENTS,
      api: AppointmentsApi.getPastAppointments,
      successCallback: response => {
        dispatch({
          type: types.GET_PAST_APPOINTMENTS,
          payload: response.appointments,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const getUpcomingAppointments = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_UPCOMING_APPOINTMENTS,
      api: AppointmentsApi.getUpcomingAppointments,
      successCallback: response => {
        dispatch({
          type: types.GET_UPCOMING_APPOINTMENTS,
          payload: response.appointments,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const requestAppointment = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.REQUEST_APPOINTMENT,
      api: AppointmentsApi.requestAppointment,
      param: data,
      successCallback: response => {
        // We only need to invoke a cb in the AppointmentRequest for internal state
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const sendAppointmentMessage = (messageData, successCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.SEND_APPOINTMENT_MESSAGE,
      api: AppointmentsApi.sendAppointmentMessage,
      param: messageData,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Message Sent',
          content: 'We successfully sent your message about your appointment.',
          okCallback: () => {
            // Refresh after message sent success - acting as a allback, this closes the panel on Mobile
            dispatch(getUpcomingAppointments());
            dispatch(getPastAppointments());

            return true;
          },
        }));

        // For turning off fullPageLoadingState in the component
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        dispatch(openErrorDialog({
          title: 'Unable to Email',
          content: response.message.body,
        }));
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/appointments/appointmentsActions.js